import React, { Suspense } from 'react';
import { motion } from 'framer-motion';

import MyCarousel from "./Carousel";
import { styles } from "../styles";
import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant, slideIn } from "../utils/motion";
import VideoCarousel from "./VideoCarousel"; // Component for video thumbnails


const About = () => {
  const carouselSlides = [
    <img key="slide1" src="src/assets/j1.jpg" alt="Image 1" />,
    <img key="slide1" src="src/assets/j2.jpg" alt="Image 2" />,
    <img key="slide2" src="src/assets/monochrome.jpg" alt="Image 3" />,
    <img key="slide3" src="src/assets/w.jpeg" alt="Image 4" />,
    <img key="slide4" src="src/assets/b.jpg" alt="Image 5" />,
  ];

  const videoThumbnails = [
    {
      title: "Manavta (Fair for All)",
      description: "Promovideo van Fair Trade-producten, Manavta",
      videoUrl: "https://www.youtube.com/embed/bz0UQI3VHgA",
    },
    {
      title: "Manushi Nepal",
      description: "Ontdek ons Fair Trade handwerk uit Nepal",
      videoUrl: "https://www.youtube.com/embed/zzydyUa1iRA",
    },
    {
      title: "Leaf Plus Nepal",
      description: "Hoe worden de bladproducten geproduceerd?",
      videoUrl: "https://www.youtube.com/embed/bJw2kI9Q9hg",
    },
    {
      title: "Hemp Fabric Production",
      description: "Op weg naar duurzame kleding",
      videoUrl: "https://www.youtube.com/embed/fx9Z7powWPg",
    },
    {
      title: "Ecofriendly Leaf Products",
      description: "Sociale, milieuvriendelijke en biologisch afbreekbare bladproducten",
      videoUrl: "https://www.youtube.com/embed/m6VA7pCiyu0",
    },
    {
      title: "VOORDELEN VAN HENNEPZADEN",
      description: "Gezondheidsvoordelen van hennepzaadolie voor haar en huid",
      videoUrl: "https://www.youtube.com/embed/HXtUuWUhWLs",
    },
  ];

  return (
    <>
      <motion.div variants={textVariant()}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
          <div className="sm:col-span-1">
            <motion.div variants={slideIn()}>
              <p className="font-normal text-lg text-secondary">Introductie</p>
              <h2 className="font-bold text-3xl text-white">Overzicht.</h2>
              <motion.p
                variants={fadeIn("", "", 0.1, 1)}
                className={`mt-4 ${styles.sectionSubText} text-secondary max-w-3xl leading-[30px]`}
              >
                Ramro Imports B.V. importeert producten van o.a. hennep, katoen en vilt uit Nepal. Voor consumenten verkopen wij via fairtrade en fairmade producten onder onze merknaam Manavta op Manavta.nl. Voor groothandel kunt u hier terecht.
                <br /><br />
                Ramro betekent goed in Nepalees. Wij bieden dan ook kwalitatief goede producten aan voor een eerlijke prijs.
                <br /><br />
                Nepal heeft prachtige kundige vakmensen. Veel producten worden hier nog op ambachtelijke wijze gemaakt. In andere delen van de wereld zou dat de producten voor veel mensen onbetaalbaar maken, maar in Nepal liggen de prijzen en kosten van levensonderhoud veel lager dan in Europa. Daardoor kunnen we veel handgemaakte producten voor een redelijke prijs aanbieden.
                <br /><br />
                Onze partner in Nepal en Fair Trade International zien erop toe dat fairtrade producten gemaakt worden volgens de fairtrade normen.
                <br /><br />
                Wij bieden producten aan particuliere en zakelijke klanten aan, een deel is op voorraad en een deel op bestelling. Neem contact met ons op via het contactformulier of telefoon.
              </motion.p>
            </motion.div>
          </div>

          <div className="sm:col-span-1">
            <motion.div variants={slideIn()}>
              <h3 className="font-bold text-3xl text-white">Verhalen</h3>
              <div className="mt-4 overflow-y-auto h-full">
                <Suspense fallback={<div>Loading...</div>}>
                  <VideoCarousel videoThumbnails={videoThumbnails} />
                </Suspense>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mt-10">
        <div className="sm:col-span-1">
          <motion.div variants={slideIn()}>
            <Suspense fallback={<div>Loading...</div>}>
              <MyCarousel slides={carouselSlides} autoSlide autoSlideInterval={3000} />
            </Suspense>
          </motion.div>
        </div>

        <div className="sm:col-span-1">
          <motion.div variants={slideIn()}>
            <h3 className="font-bold text-3xl text-white">Sustainability</h3>
            <motion.p
              variants={fadeIn("", "", 0.1, 1)}
              className={`mt-4 ${styles.sectionSubText} text-secondary max-w-3xl leading-[30px]`}
            >
              Ramro Imports staat voor import van duurzame producten. In landen als Nepal verdwijnt de zorg voor het milieu onder economische druk regelmatig op de achtergrond. Een milieuvriendelijke productiewijze staat bij ons voorop.
              <br /><br />
              Producten van hennep, palmbladeren en papier zijn beter voor het milieu dan katoen, plastic en metalen. We willen bijdragen aan een planeet waarin grondstoffen hergebruikt worden en de natuur niet vervuild wordt door schadelijke stoffen.
              <br /><br />
              Nog niet al onze verpakkingen zijn plastic vrij, maar we werken er met onze producenten hard aan om dit in de nabije toekomst te realiseren. Een circulaire economie, de natuur laat ons zelf zien hoe het hoort.
            </motion.p>
            <motion.p
              variants={fadeIn("", "", 0.1, 1)}
              className={`mt-4 ${styles.sectionSubText} text-secondary max-w-3xl leading-[30px]`}
            >
              <span>"The greatest threat to our planet is the belief that someone else will save it." - Robert Swan</span>
            </motion.p>
          </motion.div>
        </div>
      </div>

  

     
    </>
  );
};

export default SectionWrapper(About, "about");
